// THE entry point for recessed-light layout. Pure: no THREE, no Firestore.
// Pipeline: perimeter ring + sparse interior → obstruction shift-else-drop →
// ceiling seating (per-XZ facet Y, slope tilt, never float a can).
// Design doc: claude-docs/2026-08-06-recessed-light-layout-design.md
const DEFAULTS = require('./constants');
const { signedPolygonArea } = require('./polygonMath');
const { perimeterCandidates } = require('./perimeterCandidates');
const { interiorCandidates } = require('./interiorCandidates');
const {
  findObstructionFootprints,
  resolveObstructions,
} = require('./obstructions');
const {
  seatCandidates,
  makeCeilingYLookup,
  deriveFlatCeilingY,
} = require('./ceilingSeat');
const {
  calculatePolygonCentroid,
} = require('../vanity-assembly/placementUtils');

function layoutRecessedLights({
  floorPolygon,
  ceilings = [],
  walls = [],
  objects = [],
  options = {},
} = {}) {
  const C = { ...DEFAULTS, ...options };
  if (!Array.isArray(floorPolygon) || floorPolygon.length < 3) return [];
  // Collinear/degenerate "polygon" (zero area) has no interior — don't emit
  // a centroid can for it.
  if (Math.abs(signedPolygonArea(floorPolygon)) < 1e-6) return [];

  const fallbackY = deriveFlatCeilingY(ceilings, walls);

  const perim = perimeterCandidates(floorPolygon, C);
  const inter = interiorCandidates(floorPolygon, perim, C);

  const getCeilingYAt = makeCeilingYLookup(ceilings, fallbackY);
  const footprints = findObstructionFootprints(objects, getCeilingYAt, C);
  const resolved = resolveObstructions(
    [...perim, ...inter],
    footprints,
    floorPolygon,
    C
  );

  let seated = seatCandidates(resolved, ceilings, fallbackY, C);
  if (seated.length === 0) {
    const centroid = calculatePolygonCentroid(floorPolygon);
    if (centroid) {
      seated = seatCandidates([centroid], ceilings, fallbackY, C);
    }
  }
  return seated;
}

module.exports = { layoutRecessedLights };
